module.exports = __webpack_public_path__ + "img/google-2.a63a62ee.svg";